import { Component, OnInit } from '@angular/core';
import { YtbesprechungStoreService } from '../../services/ytbesprechung-store.service';
import { map, shareReplay, tap } from 'rxjs/operators';
import { FlimmoMetaService } from '../../../../core/services/flimmo-meta.service';
import { TranslateService } from '@ngx-translate/core';
import { YTBesprechung } from '../../../../generated-api';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-ytbesprechung-page',
  templateUrl: './ytbesprechung-page.component.html',
  styleUrls: ['./ytbesprechung-page.component.scss'],
  standalone: false,

  host: { ngSkipHydration: 'true' },
})
export class YtbesprechungPageComponent implements OnInit {
  public ytbs$: Observable<YTBesprechung>;
  
  constructor(
    public store: YtbesprechungStoreService,
    private breakpointObserver: BreakpointObserver,
    private flimmoMetaService: FlimmoMetaService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.ytbs$ = this.store.selectedYTBesprechung$.pipe(
      tap((data: YTBesprechung) => {
        if (data?.title) {
          this.flimmoMetaService.setFlimmoTitle(
            this.translateService.instant('ytb.seo.title') + ': ' + data.title
          );
          if (data.content) this.flimmoMetaService.setDescription(data.content);
          this.flimmoMetaService.setOG('/ytbesprechung/' + data.id, data.image);
        }
      })
    );

    this.flimmoMetaService.setFlimmoTitle(
      this.translateService.instant('ytb.seo.title')
    );
    this.flimmoMetaService.setDescription(
      this.translateService.instant('ytb.seo.description')
    );
  }
}
